import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  href?: string;
  target?: string;
  onLinkClick?: () => void;
};
export function Button({
  children,
  className = '',
  href,
  target,
  onLinkClick,
  ...props
}: ButtonProps) {
  const style = `inline-flex items-center justify-center rounded-full bg-gold-gradient px-7 py-4 text-sm font-bold text-black shadow-[0_0_22px_rgba(212,175,55,.3)] transition-shadow hover:shadow-[0_0_30px_rgba(245,208,97,.52)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-light ${className}`;
  return href ? <motion.a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={onLinkClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={style} data-id="element-37">
      {children}
    </motion.a> : <motion.button {...props} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={style} data-id="element-38">
      {children}
    </motion.button>;
}